import { Pipe, PipeTransform } from '@angular/core';
import { API_PARAMS } from '../shared/constants/api.constants';

/**
 * 自覺症狀疾病管道：value添加前綴
 */
@Pipe({
  name: 'subjectiveSymptomDisease',
  standalone: true,
})
export class SubjectiveSymptomDiseasePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    return `${API_PARAMS.QUESTIONNAIRE_DISEASE_PREFIX.SUBJECTIVE_SYMPTOMS}${value}`;
  }
}
